export enum QueryBuilderActionType {
  INIT = 'INIT',
  INIT_QUERY = 'INIT_QUERY',
  SET_QUERY = 'SET_QUERY',
  RESET_QUERY = 'RESET_QUERY',
  SET_METADATA = 'SET_METADATA',
}
